import React from "react";

interface Props {
  children?: React.JSX.Element | Array<React.JSX.Element>;
}

export const FixedWebWidthContentWrapper = (props: Props) => {
  const { children } = props;

  return <div className="fixed-web-width-content-wrapper">{children} </div>;
};
